import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { UserDataModel } from '@app/models/auth/userData.model';
import { AuthService } from '@app/services/auth.service';
import { LocalisationService } from '@app/services/localisation.service';

import { Globals } from './../../../../globals';

@Component({
  selector: 'app-right-to-erasure',
  templateUrl: './right-to-erasure.component.html',
  styleUrls: ['./right-to-erasure.component.scss']
})
export class RightToErasureComponent implements OnInit {
  static route = 'account/right-to-erasure';

  locale: any = {};

  // BaseManagePasswordComponent template variables to be passed
  templateSettings: any = {};

  passwordForm: FormGroup;
  resetPasswordSubmitted: boolean = false;
  passwordLength: number;
  formSubmitted: boolean = false;

  messageCopy: string = null;
  messageClass: string = this.globals.styles.alertClass;

  constructor(
    public globals: Globals,
    public localisation: LocalisationService,
    public authService: AuthService,
    public formBuilder: FormBuilder,
    private sanitizer: DomSanitizer,
    private router: Router
  ) {}

  ngOnInit() {
    this.locale = this.localisation.getTranslationsForComponent('RightToErasureComponent');

    this.templateSettings = {
      header: this.locale.header,
      formParagraph: this.locale.formParagraph,
      submit: this.locale.submit
    };

    this.passwordForm = this.formBuilder.group({
      password: [null, [Validators.required]]
    });
  }

  setFormSubmitted(value) {
    this.formSubmitted = value;
  }

  submitForm(model: UserDataModel) {
    this.resetPasswordSubmitted = true;

    if (!this.passwordForm.valid) {
      return;
    }
    this.setFormSubmitted(true);
    this.sendForm(model);
  }

  sendForm(model: any) {
    // Reset the form ready for new input
    this.setFormSubmitted(false);
    this.resetPasswordSubmitted = false;
    this.passwordForm.reset();
    this.authService.deleteGdprData(model).subscribe(
      succeed => {
        // Logout
        sessionStorage.removeItem('token');
        this.authService.setSignedOut(true);
        this.router.navigate(['/login']);
      },
      err => {
        this.messageCopy = err.returnCode.message;
        this.messageClass = this.globals.styles.errorClass;
      }
    );
  }

  // Clear messages when input fields are active
  onClickInput() {
    this.messageCopy = null;
    this.messageClass = this.globals.styles.alertClass;
  }

  goBack() {
    window.history.back();
  }
}



// WEBPACK FOOTER //
// ./src/app/components/account/right-to-erasure/right-to-erasure.component.ts